












































































import { Component, Vue } from 'vue-property-decorator';
import CommonButton from '@/components/common/CommonButton.vue';
import { Auth } from 'aws-amplify';
import { vxm } from '@/store';
import { CognitoHostedUIIdentityProvider } from '@/@types/LibraryComponent';

@Component({
  components: {
    CommonButton,
  },
})
export default class LoginBase extends Vue {
  private textFieldColor: string = '#3c3c3c';
  private email: string = '';
  private password: string = '';
  private message: string = '';
  private showPassword: boolean = false;

  private setMessage(message: string): void {
    this.message = message;
  }

  private async onSignIn(): Promise<void> {
    if (this.email === '' && this.password === '') {
      this.setMessage('メールアドレスとパスワードが入力されていません');
      return;
    } else if (this.email === '') {
      this.setMessage('メールアドレスが入力されていません');
      return;
    } else if (this.password === '') {
      this.setMessage('パスワードが入力されていません');
      return;
    } else {
      this.setMessage('');
    }
    try {
      const user = await Auth.signIn(this.email, this.password);
      /** SMSテキストメッセージ・ワンタイムパスワードを採用する場合ここでキャッチする */
      if (
        user.challengeName === 'SMS_MFA' ||
        user.challengeName === 'SOFTWARE_TOKEN_MFA'
      ) {
        return;
        /** Cognitoコンソールで作成したユーザーが最初にサインインするときに起こる
         * Auth.completeNewPassword() で新しいパスワードと必要な属性を入力する必要がある
         * (使う場面は限定的)
         */
      } else if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        await Auth.completeNewPassword(user, this.password, {
          email: this.email,
        });
        /** ワンタイムパスワードを採用する場合、セットアップ手順未完了のエラーをキャッチする */
      } else if (user.challengeName === 'MFA_SETUP') {
        return;
      } else {
        this.setMessage('ログインしました');
        /** ここでログインAPIへアクセスしてストアに情報を保存する */
        await vxm.theoryApi.authStore.fetchCurrentUserInfo();
        const userInfo = vxm.theoryApi.authStore.getCurrentUserInfo?.results;
        if (userInfo) {
          if (userInfo.organizationId) {
            /**組織IDをsetし、組織のプロジェクトのうちアカウントが現在参画しているものの一覧をstateにset */
            vxm.theoryApi.authStore.fetchCurrentOrganizationId(userInfo.organizationId);
            await vxm.theoryApi.accountsStore.fetchAccountBasicParticipationProjects({
              accountId: userInfo.accountId,
              organizationId: userInfo.organizationId,
            });
            /**プロジェクトIDsをセット */
            if (vxm.theoryApi.accountsStore.getAccountBasicParticipationProjects) {
              const projectIds = vxm.theoryApi.accountsStore.getAccountBasicParticipationProjects.results.map(
                (project) => {
                  return project.projectId;
                }
              );
              vxm.theoryApi.authStore.fetchCurrentProjectIds(projectIds);
            }
          }
          if (userInfo.projectId) {
            vxm.theoryApi.authStore.fetchCurrentProjectId(userInfo.projectId);
          }
        } else {
          this.setMessage('予期しないエラーが発生しました');
          return;
        }
        this.$router.push({ name: 'home' });
      }
    } catch (err) {
      /** ユーザーのステータスが UNCONFIRMED の場合に起こる
       * SignUp用のコードを再送し、ステータスを CONFIRMED にする必要がある
       * 対応としては、Auth.resendSignUp(username)でコードの再送をすればよい
       */
      if (err.code === 'UserNotConfirmedException') {
        this.setMessage('ユーザー登録の途中です');
        /** Cognito コンソールでパスワードをリセット（ユーザープールにユーザをインポートする場合も含む）した場合に起こる。
         * パスワードをリセットする必要がある。
         */
      } else if (err.code === 'PasswordResetRequiredException') {
        this.setMessage('パスワードを変更する必要があります');
        /** 誤ったパスワードを入力した場合に起こる。
         * 注) パスワードを間違え続けた場合にも起こり、 error.message が 'Password attempts exceeded' になる。
         */
      } else if (err.code === 'NotAuthorizedException') {
        this.setMessage('ユーザー名またはパスワードが異なります');
        /** PASSWORD_VERIFIER は通るものの username が Cognito ユーザープールに存在しない場合に起こる。 */
      } else if (err.code === 'UserNotFoundException') {
        this.setMessage('ユーザー名またはパスワードが異なります');
        /** 入力された username や password が Cognito 側で正しくパースできないとき（バリデーションエラー）に起こる。 */
      } else if (err.code === 'InvalidParameterException') {
        this.setMessage('ユーザー名またはパスワードが異なります');
      } else {
        this.setMessage('予期しないエラーが発生しました');
      }
    }
  }

  private async onSocialSignIn(): Promise<void> {
    const googleOptions = {
      provider: CognitoHostedUIIdentityProvider.Google,
    };
    try {
      await Auth.federatedSignIn(googleOptions);
    } catch (err) {
      this.setMessage('予期しないエラーが発生しました');
    }
  }
}
